var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80441 0.861766C8.54406 0.601417 8.12195 0.601417 7.8616 0.861766L0.52827 8.1951C0.403246 8.32012 0.333008 8.48969 0.333008 8.6665V11.3332C0.333008 11.7014 0.631485 11.9998 0.999674 11.9998H3.66634C3.84315 11.9998 4.01272 11.9296 4.13775 11.8046L11.4711 4.47124C11.7314 4.21089 11.7314 3.78878 11.4711 3.52843L8.80441 0.861766ZM1.66634 10.6665V8.94265L8.33301 2.27598L10.0569 3.99984L3.3902 10.6665H1.66634ZM12.9997 13.9998H0.999674C0.631485 13.9998 0.333008 14.2983 0.333008 14.6665C0.333008 15.0347 0.631485 15.3332 0.999674 15.3332H12.9997C13.3679 15.3332 13.6663 15.0347 13.6663 14.6665C13.6663 14.2983 13.3679 13.9998 12.9997 13.9998Z",
    fill: "#FB7B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditingIcon);
export default __webpack_public_path__ + "static/media/editing-icon.8b8d95854a1e90d89d4759e67e815aea.svg";
export { ForwardRef as ReactComponent };